module.exports = __webpack_public_path__ + "8b6064d29716a64def41b1b5d00ad18f.png";